// import { EIntegrationTypes } from '../views/AdminPanelView/components/AdminPanel/components/SocialPlaner/scheduler/utils/enums';
import { BaseUrl } from '@utils/httpClient.js';

import { sectionTypes } from './sectionEnums';

export const getCampaignMap = (camp) => {
  let activeIntegrations = [];

  // if (camp['isFacebook']) {
  //   activeIntegrations.push(EIntegrationTypes.FACEBOOK);
  // }
  // if (camp['isTwitter']) {
  //   activeIntegrations.push(EIntegrationTypes.TWITTER);
  // }
  // if (camp['isInstagram']) {
  //   activeIntegrations.push(EIntegrationTypes.INSTAGRAM);
  // }
  //
  // if (camp['isTelegram']) {
  //   activeIntegrations.push(EIntegrationTypes.TELEGRAM);
  // }
  //
  // if (camp['isPinterest']) {
  //   activeIntegrations.push(EIntegrationTypes.PINTEREST);
  // }
  //
  // if (camp['isLinkedin']) {
  //   activeIntegrations.push(EIntegrationTypes.LINKEDIN);
  // }

  // If image already contains a full URL (starts with http), use as-is.
  // Otherwise, prefix with /content/ for defaults (no-picture), /upload/ for filenames.
  const rawImage = camp?.image;
  const image = !rawImage
    ? ''
    : rawImage.startsWith('http://') || rawImage.startsWith('https://')
      ? rawImage
      : rawImage.includes('no-picture')
        ? `${BaseUrl}/content/${rawImage}`
        : `${BaseUrl}/upload/${rawImage}`;

  return {
    id: camp.id,
    content: camp.content,
    name: camp.title,
    image,
    date: camp.date,
    scheduledDate: camp['scheduledDate'],
    status: camp.status,
    likes: camp['likeCount'],
    comments: camp['commentCount'],
    reposts: camp['repostCount'],
    impressions: camp['impressionCount'],
    views: camp['viewCount'],
    activeIntegrations,
    posts: camp.posts,
  };
};

export const getUnlinkItemMap = (item) => {
  return {
    ...item,
    postLink: item['permalink'],
    isDirectMessage: item['hasDmButton'],
    isCustomMedia: item['isCustom'],
    CTAButtonTextColor: item['textColor'],
    CTAButtonBackgroundColor: item['backgroundColor'],
    isForwardMedia: item['isForward'],
  };
};

export const getOutfitTagItemMap = (item) => ({
  id: item['id'],
  mediaId: item['mediaId'],
  tag_position_x: item['tag_position_x'] ?? item['tagPositionX'] ?? 0,
  tag_position_y: item['tag_position_y'] ?? item['tagPositionY'] ?? 0,
  media_width: item['media_width'] ?? item['mediaWidth'] ?? 0,
  media_height: item['media_height'] ?? item['mediaHeight'] ?? 0,
  url: item['url'] ?? '',
  title: item['title'] ?? '',
  price: item['price'] ?? item['tag_price'] ?? 0,
  oldprice: item['oldprice'] ?? item['tag_oldprice'] ?? 0,
  currency: item['currency'] ?? item['tag_currency'] ?? '',
  image: item['image'] ?? item['tag_image'] ?? '',
  type: item['type'] ?? item['tag_type'] ?? 1,
  instagramMediaId: item['instagramMediaId'] ?? item['tag_instagram_media_id'] ?? 0,
});

export const getTikTokTagsItemMap = (item) => ({
  id: item['id'],
  mediaId: item['mediaId'],
  url: item['url'],
  title: item['title'],
  price: item['price'],
  oldprice: item['oldprice'],
  currency: item['currency'],
  image: item['image'],
  type: item['type'],
  instagramMediaId: item['instagramMediaId'],
});

export const getTikTokMediaItemMap = (item) => {
  let tags = [];

  if (Array.isArray(item['tags'])) {
    item['tags'].forEach((tag) => tags.push(getTikTokTagsItemMap(tag)));
  }

  return {
    id: item['id'],
    cover: item['cover'],
    description: item['description'],
    dynamicCover: item['dynamicCover'],
    identity: item['identity'],
    tikTokUserId: item['tikTokUserId'],
    timestamp: item['timestamp'],
    userId: item['userId'],
    isActive: item['isActive'],
    videoUrl: item['videoUrl'],
    tags,
  };
};

export const getTikTokUserItemMap = (item) => {
  return {
    id: item['id'],
    avatarThumb: item['avatarThumb'],
    followersCount: item['followersCount'],
    followingCount: item['followingCount'],
    profileId: item['profileId'],
    identity: item['identity'],
    secUId: item['secUId'],
    uniqueId: item['uniqueId'],
    userId: item['userId'],
    username: item['username'],
    videoCount: item['videoCount'],
  };
};

export const getYouTubeMediaItemMap = (item) => {
  let tags = [];

  if (Array.isArray(item['tags'])) {
    item['tags'].forEach((tag) => tags.push(getTikTokTagsItemMap(tag)));
  }

  return {
    id: item['id'],
    image: item['image'],
    title: item['title'],
    isActive: item['isActive'],
    link: item['link'],
    externalId: item['externalId'],
    tags,
  };
};

export const getUnlinkButtonLinksMap = (item) => {
  // BlockId: 4447
  // Document: null
  // FolderId: null
  // IGUserId: 34065
  // IsForward: false
  // IsRightArrowAnimate: null
  // SectionId: null
  // UrlRaw: "https://www.beneteau.com/oceanis/oceanis-511"

  return {
    id: item['id'],
    title: item['title'],
    url: item['url'],
    description: item['description'],
    isActive: item['isActive'],
    isCustomDesign: item['isCustomDesign'],
    n: item['n'],
    animation: item['animation'],
    backgroundLinkColor: item['backgroundColor'],
    backgroundLinkColorRGBA: item['backgroundRGBA'],
    opacity: item['opacity'],
    height: item['height'],
    imageHeight: item['imageHeight'],
    textLinkColor: item['textColor'],
    textLinkAlign: item['textAlign'],
    image: item['image'],
    imageShape: item['imageShape'],
    sectionTitle: item['headerTitle'],
    sectionSubtitle: item['headerDescription'],
    sectionTextAlign: item['headerTextAlign'],
    sectionImage: item['headerImage'],
    sectionDevided: item['headerDevided'],
    sectionTextColor: item['headerTextColor'],
    isDisplayArrow: item['isDisplayArrow'], //not available on the backend
    actionType: item['actionType'],
    urlType: item['urlType'],
    rightArrow: item['rightArrow'],
    isBorder: item['isBorder'],
    postButtonColor: item['postButtonColor'],
    postButtonTitle: item['postButtonTitle'],
    postButtonUrl: item['postButtonUrl'],
    postDescription: item['postDescription'],
    postImage: item['postImage'],
    postTitle: item['postTitle'],
    internalPageId: item['internalPageId'],

    button: item['button'],
    buttonColor: item['buttonColor'],
    label: item['label'],
    labelColor: item['labelColor'],

    isLock: item['isLock'],
    isPayable: item['isPayable'],
    lockData: item['lockData'],
    lockType: item['lockType'],
    price: item['price'],

    isGradient: item['isGradient'],
    gradientColor1: item['gradientColor1'],
    gradientColor2: item['gradientColor2'],
    gradientDirection: item['gradientDirection'],
    gradientOffset: item['gradientOffset'],
  };
};

export const getBackUnlinkButtonLinksMap = (item) => {
  return {
    Id: item['id'],
    Title: item['title'],
    Url: item['url'],
    Description: item['description'],
    IsActive: item['isActive'],
    IsCustomDesign: item['isCustomDesign'],
    N: item['n'],
    Animation: item['animation'],
    BackgroundColor: item['backgroundLinkColor'],
    BackgroundRGBA: item['backgroundLinkColorRGBA'],
    TextColor: item['textLinkColor'],
    Image: item['image'],
    ImageShape: item['imageShape'],
    SectionTitle: item['headerTitle'],
    SectionSubtitle: item['headerDescription'],
    SectionTextAlign: item['headerTextAlign'],
    Opacity: item['opacity'],
    Height: item['height'],
    ImageHeight: item['imageHeight'],
    SectionImage: item['headerImage'],
    SectionDevided: item['headerDevided'],
    SectionTextColor: item['headerTextColor'],
    IsDisplayArrow: item['isDisplayArrow'],
    ActionType: item['actionType'],
    RightArrow: item['rightArrow'],
    IsBorder: item['isBorder'],
    PostButtonColor: item['postButtonColor'],
    PostButtonTitle: item['postButtonTitle'],
    PostButtonUrl: item['postButtonUrl'],
    PostDescription: item['postDescription'],
    PostImage: item['postImage'],
    PostTitle: item['postTitle'],
    Clicks: item['clicks'],
    InternalPageId: item['internalPageId'],

    Button: item['button'],
    ButtonColor: item['buttonColor'],
    Label: item['label'],
    LabelColor: item['labelColor'],
  };
};

export const getHeroMediaItemMap = (item) => {
  return {
    ...item,
    heroType: item['heroActionType'],
  };
};

export const getUnilinkDataMap = (data) => {
  const { blocks } = data;

  /* --- Header section --- */

  /* --- Banner section --- */

  let heroMedia = null;

  const bannerSection = blocks.filter((el) => el?.type === sectionTypes.banner.type)[0];

  if (bannerSection) {
    if (bannerSection?.data?.heroMedia) {
      heroMedia = getHeroMediaItemMap(bannerSection.data.heroMedia);
    }
  }

  /* --- Shop section --- */

  let media = [];
  let custom = [];
  let tikTokMedia = [];
  let tikTokUser = {};

  const shopSection = blocks.filter((el) => el?.type === sectionTypes.shop.type)[0];
  const tikTokSection = blocks.filter((el) => el?.type === sectionTypes.tiktok.type)[0];

  if (shopSection) {
    if (Array.isArray(shopSection?.data?.mediaex)) {
      shopSection.data.mediaex.forEach((el) => media.push(getUnlinkItemMap(el)));
    }

    if (Array.isArray(shopSection?.data?.custom)) {
      shopSection.data.custom.forEach((el) => custom.push(getUnlinkItemMap(el)));
    }
  }

  if (tikTokSection) {
    if (Array.isArray(tikTokSection?.data?.tiktok?.media)) {
      tikTokSection.data.tiktok.media.forEach((el) => tikTokMedia.push(getTikTokMediaItemMap(el)));
    }

    if (tikTokSection?.data?.tiktok?.user) {
      tikTokUser = getTikTokUserItemMap(tikTokSection.data.tiktok.user);
    }
  }

  return {
    user: {
      profileId: data['id'],
      userId: data['userId'],
      identity: data['identity'],
      username: data['username'],
      isPro: data['isPro'],
      status: data['status'],

      balance: data['balance'],
      apiKey: data['apiKey'],
      accessToken: data['accessToken'],
      wizardStatus: data['wizardStatus'],

      sections: data['blocks'],
      design: data['design'],
      settings: data['settings'],
      forward: data['forward'],
      spotlight: data['spotlight'],

      pages: data['pages'],
      profilePicUrl: data['profilePicUrl'],
      homePageTitle: data['homePageTitle'],
      accountSettings: data['user'],
      tabs: data['tabs'],
      posts: data['posts'],
    },
    // links,
    media,
    custom,
    tikTokMedia,
    tikTokUser,
    // social,
    heroMedia,
  };
};

export function getUnilinkUserListMap(data) {
  return {
    profileId: data['id'],
    username: data['username'],
    avatarUrl: data['profilePicUrl'],
    accountId: data['id'],
    userId: data['userId'],
    unilinkUrl: data['unilinkUrl'],
  };
}

export const getUnilinkAccountListMap = (data) => {
  const { profile: userData, profiles: userListData, board } = data;

  let user = null;
  let userList = [];

  if (userData) {
    user = getUnilinkDataMap(userData);
  }

  if (Array.isArray(userListData)) {
    userListData.forEach((el) => userList.push(getUnilinkUserListMap(el)));
  }

  let responses = {};
  let notifs = [];
  let total = 0;
  let unique = 0;
  let wallet = 0;
  let actions = 0;

  if (board && board?.responses) {
    const { responses: responsesData, notifs: notifsData, total: totalData, unique: uniqueData, wallet: walletData, actions: actionsData } = board;

    responses = responsesData;
    notifs = notifsData;
    total = totalData;
    unique = uniqueData;
    wallet = walletData;
    actions = actionsData;
  }

  return {
    user,
    userList,
    board: {
      responses,
      notifs,
      total,
      unique,
      actions,
      wallet,
    },
  };
};

export const getAccountMap = (data) => {
  const { profile, profiles, board, user, templates, themes, palettes, announcement } = data;

  const { userId, username, id: profileId, profilePicUrl, forward, isDisplayPreviewStore, storePreviewProducts, shareQRCode, previewQRCode, notifications } = profile;
  const { email, lang, photo: userPicUrl, status, subscriptionStatus, fullName, apiKey } = user;

  let userList = [];

  if (Array.isArray(profiles)) {
    profiles.forEach((el) => userList.push(getUnilinkUserListMap(el)));
  }

  let responses = {};
  let notifs = [];
  let total = 0;
  let unique = 0;
  let wallet = 0;
  let actions = 0;

  if (board && board?.responses) {
    const { responses: responsesData, notifs: notifsData, total: totalData, unique: uniqueData, wallet: walletData, actions: actionsData } = board;

    responses = responsesData;
    notifs = notifsData;
    total = totalData;
    unique = uniqueData;
    wallet = walletData;
    actions = actionsData;
  }

  return {
    userId,
    username,
    profileId,
    profilePicUrl,
    email,
    lang,
    userPicUrl,
    userList,
    status,
    subscriptionStatus,
    fullName,
    apiKey,
    notifications,
    user: getUnilinkDataMap(profile),
    board: {
      notifications: board?.notifications,

      leadNotifications: board?.leadNotifications,
      chatNotifications: board?.chatNotifications,

      responses,
      notifs,
      total,
      unique,
      actions,
      wallet,
    },

    templates,
    themes,
    palettes,
    forward,
    isDisplayPreviewStore,
    storePreviewProducts,
    shareQRCode,
    previewQRCode,
    announcement: announcement || null,
  };
};
